import React from 'react'
// import ChangePassword from './ChangePassword';
import ChangePwd from '../components/ChangePwd';
import { useResetPasswordMutation } from '../redux/auth/authService';
import { toast } from 'react-toastify';

const ChangePassword = () => {

   const location = window.location.href;
   const code = new URLSearchParams(location.split('?')[1]).get('code');

   const [resetPassword, { isLoading }] = useResetPasswordMutation();



console.log("location", location);

    const send = () => {
        let data = {
            password: document.getElementById("password").value,
            passwordConfirmation: document.getElementById("passwordConfirmation").value,
        };
        data.code = code;
        console.log("Password changed successfully");
        resetPassword(data).unwrap()
        .then((response) => {
            console.log("Response:", response);
            toast.success("Password changed successfully");
            // Handle success, e.g., show a success message or redirect
        })
        .catch((error) => {
            console.error("Error changing password:", error);
            toast.error("Error changing password");

            // Handle error, e.g., show an error message
        });
    }

  return (
    <div className='w-full'>
        <ChangePwd send={send} />
      
    </div>
  )
}

export default ChangePassword
